import { render, staticRenderFns } from "./AnnouncementRemove.vue?vue&type=template&id=6f140a04&scoped=true&"
import script from "./AnnouncementRemove.vue?vue&type=script&lang=js&"
export * from "./AnnouncementRemove.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementRemove.vue?vue&type=style&index=0&id=6f140a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f140a04",
  null
  
)

export default component.exports